import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";


export const getLotes = async () => {
  const respuesta = await PrivateInterceptor(`MateriaPrima/Lotes`, "GET");
  return respuesta;
};

export const GuardarLote = (Datos) => {
  const respuesta = PrivateInterceptor("MateriaPrima/GuardarLote", "POST", {Datos});
  return respuesta;
};

export const EditarLote = (Datos) => {
  const respuesta = PrivateInterceptor("MateriaPrima/EditarLote", "POST", {Datos});
  return respuesta;
};


